/**
 * Home dashboard — reporting-service (`/api/v1/reporting`) with date range query params.
 */

import { reportingApiFetch, reportingPath } from "@/lib/reportingApi";

/** @param {{ startDate: string, endDate: string }} range */
function rangeQuery(range) {
  const sp = new URLSearchParams();
  if (range?.startDate && range?.endDate) {
    sp.set("start_date", range.startDate);
    sp.set("end_date", range.endDate);
    return `?${sp.toString()}`;
  }
  sp.set("days", "7");
  return `?${sp.toString()}`;
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchDailyChats(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/dailychats")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchCompletionRate(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/completion_rate")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchResolutionTimes(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/human-agent/resolution-times")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchCsatScore(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/csat_score")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchHandoffStats(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/human-agent/handoff-stats")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchLeaderboard(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/human-agent/leaderboard")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {RequestInit} [init] */
export function fetchConversationVolume(range, init = {}) {
  return reportingApiFetch(`${reportingPath("/human-agent/conversation-volume")}${rangeQuery(range)}`, init);
}

/** @param {{ startDate: string, endDate: string }} range @param {{ limit?: number }} [opts] @param {RequestInit} [init] */
export function fetchActivityFeed(range, opts = {}, init = {}) {
  const sp = new URLSearchParams();
  if (range?.startDate && range?.endDate) {
    sp.set("start_date", range.startDate);
    sp.set("end_date", range.endDate);
  } else {
    sp.set("days", "7");
  }
  const lim = opts.limit != null ? Math.min(50, Math.max(1, Number(opts.limit))) : 10;
  sp.set("limit", String(lim));
  return reportingApiFetch(`${reportingPath("/human-agent/activity-feed")}?${sp.toString()}`, init);
}
